const emailModal = (state = false, action) => {
  return action.type === 'EMAIL_MODAL' ? action.payload : state
}

export default emailModal
